import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import useLatestVideo from '../../../../hooks/useLatestVideo';
import fallbackThumbnail from '../../../../assets/images/sermon/video-thumbnail.jpg';
import './AboutBeliefsSection.scss';

const AboutBeliefsSection = () => {
    const { t } = useTranslation();
    const { videoUrl, channelUrl, thumbnail, title } = useLatestVideo();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const scaleReveal = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, scale: 0.98 },
              whileInView: { opacity: 1, scale: 1 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.2, delay: 0.3, ease: EASE_OUT_EXPO },
          };

    const thumbnailSrc = thumbnail || fallbackThumbnail;
    const thumbnailAlt = title || t('watch_latest_sermon');

    return (
        <section className="about-beliefs">
            <div className="about-beliefs__container">
                <motion.span className="about-beliefs__label" {...fadeUp(0)}>{t('beliefs_unite')}</motion.span>

                <motion.h2 className="about-beliefs__title" {...fadeUp(0.12, 1.1)}>{t('about_beliefs_visit_sermons')}</motion.h2>

                <motion.p className="about-beliefs__text" {...fadeUp(0.24)}>
                    {t('about_beliefs_description')}
                </motion.p>

                <motion.div className="about-beliefs__video" {...scaleReveal}>
                    <a
                        href={videoUrl}
                        className="about-beliefs__thumbnail-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={t('aria_play_video')}
                    >
                        <img
                            src={thumbnailSrc}
                            alt={thumbnailAlt}
                            className="about-beliefs__thumbnail"
                            loading="lazy"
                        />
                        <div className="about-beliefs__play-button">
                            <svg className="about-beliefs__play-icon" viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M8 5v14l11-7z" fill="currentColor" />
                            </svg>
                        </div>
                    </a>
                </motion.div>

                <motion.a
                    href={channelUrl}
                    className="button button--outline-blue"
                    target="_blank"
                    rel="noopener noreferrer"
                    {...fadeUp(0.45, 0.9)}
                >
                    {t('sermons_archive')}
                </motion.a>
            </div>
        </section>
    );
};

export default AboutBeliefsSection;
